import { render, staticRenderFns } from "./DiscountActivation.vue?vue&type=template&id=4d17fe3f&scoped=true&"
import script from "./DiscountActivation.vue?vue&type=script&lang=js&"
export * from "./DiscountActivation.vue?vue&type=script&lang=js&"
import style0 from "./DiscountActivation.vue?vue&type=style&index=0&id=4d17fe3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d17fe3f",
  null
  
)

export default component.exports